var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelfEmployed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 4.2V.6h6.25v3.6M1.875 4.2h16.25c.69 0 1.25.537 1.25 1.2v6H.625v-6c0-.663.56-1.2 1.25-1.2zM18.125 11.8v3.733c0 1.031-.56 1.867-1.25 1.867H3.125c-.69 0-1.25-.836-1.25-1.867V11.8"
  }))));
}
export default SvgIconSelfEmployed;